function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import get from 'lodash/get';
import Button from 'components/Form/Button';
import { AppContext } from 'context';
import App from 'modules/App';
import * as actions from '../../../actions';
import * as selectors from '../../../selectors';
import * as shapes from '../../../shapes';
import messages from '../../../messages';
import styles from './confirmEmail.pcss';
var _React_PureComponent;
class ConfirmEmail extends (_React_PureComponent = React.PureComponent) {
    static getDerivedStateFromProps(props, state) {
        if (state.isInProgress && !props.isInProgress && !props.hasError) {
            return {
                isInProgress: props.isInProgress,
                isSuccess: true
            };
        }
        return {
            isInProgress: props.isInProgress
        };
    }
    componentDidMount() {
        if (this.props.token) {
            if (!this.props.returnUrl) {
                this.props.onInit();
            } else {
                this.props.onConfirmEmail(this.props.token, this.props.returnUrl);
            }
        }
    }
    onResendCountdown() {
        const interval = setInterval(()=>{
            let { resendLock } = this.state;
            resendLock--;
            this.setState({
                resendLock
            });
            if (!resendLock) {
                clearInterval(interval);
            }
        }, 1000);
    }
    onSendConfirmEmail() {
        const { email, password } = this.props;
        const identityProviderKey = get(this.props.inactiveIdentity, 'identityProviderKey');
        this.props.onSendConfirmEmail(email, password, identityProviderKey);
        this.setState({
            resendLock: 60
        });
        this.onResendCountdown();
    }
    get confirmEmailStage() {
        if (!this.props.token && !this.props.returnUrl) return 0;
        if (this.state.isInProgress) return 4;
        if (this.props.hasError) {
            if (this.props.isConfirmTokenExpired) {
                return 3;
            }
            return 2;
        }
        if (this.state.isSuccess) {
            return 1;
        }
        return 0;
    }
    get headerMessage() {
        switch(this.confirmEmailStage){
            case 0:
                return messages.headers.confirmEmail;
            case 1:
                return messages.headers.confirmEmailSuccess;
            case 2:
                return messages.headers.confirmEmailFailed;
            case 3:
                return messages.headers.confirmEmailExpired;
            case 4:
                return messages.headers.confirmEmailInProgress;
            default:
                return null;
        }
    }
    renderConfirmText() {
        const identityProviderType = get(this.props.inactiveIdentity, 'identityProviderType');
        switch(identityProviderType){
            case 'ContourCloud':
                return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.confirmEmailCC));
            default:
                return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.confirmEmail));
        }
    }
    renderText() {
        switch(this.confirmEmailStage){
            case 0:
                return this.renderConfirmText();
            case 1:
                return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.confirmEmailSuccess));
            case 2:
                return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.confirmEmailFailed));
            case 3:
                return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.confirmEmailExpired));
            case 4:
                return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.confirmEmailInProgress));
            default:
                return null;
        }
    }
    renderSendButton() {
        const { resendLock } = this.state;
        const message = messages.buttons[resendLock ? 'tryAgainIn' : 'confirmEmailFailedResend'];
        return /*#__PURE__*/ _jsx(Button, {
            styleModifier: "primary",
            className: "btn--block",
            isDisabled: !!resendLock,
            onClick: ()=>this.onSendConfirmEmail(),
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, message), {
                values: {
                    resendLock
                }
            }))
        });
    }
    renderSignInButton() {
        const { returnUrl, invitationToken, inactiveIdentity } = this.props;
        const identityProviderType = get(this.props.inactiveIdentity, 'identityProviderType');
        if (invitationToken && identityProviderType !== 'ContourCloud') {
            return null;
        }
        let url = this.context.getUrl('sign-in');
        if (returnUrl && inactiveIdentity) {
            const returnUrlWithoutCreatePrompt = new URL(returnUrl);
            if (returnUrlWithoutCreatePrompt.searchParams.get('prompt') === 'create') {
                returnUrlWithoutCreatePrompt.searchParams.delete('prompt');
            }
            url += `?ReturnUrl=${encodeURIComponent(returnUrlWithoutCreatePrompt.toString())}`;
        }
        return /*#__PURE__*/ _jsx(Button, {
            type: "link",
            to: url,
            styleModifier: "primary",
            className: "btn--block btn--filled",
            isInProgress: this.props.isInProgress,
            onClick: this.props.onUnsetInactiveIdentity,
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.buttons.continue))
        });
    }
    renderSupportButton() {
        if (this.confirmEmailStage !== 2) {
            return null;
        }
        return /*#__PURE__*/ _jsx(Button, {
            type: "link",
            to: "https://support.glucocontro.online/",
            styleModifier: "transparent",
            className: "btn--block mt-6",
            data: {
                target: '_blank'
            },
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons.confirmEmailFailedSupport))
        });
    }
    renderActions() {
        switch(this.confirmEmailStage){
            case 2:
                {
                    return /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-12 col-sm-6",
                                children: this.renderSendButton()
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-12 col-sm-6",
                                children: this.renderSignInButton()
                            })
                        ]
                    });
                }
            case 3:
                return this.renderSendButton();
            case 4:
                return null;
            default:
                {
                    return /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-12 col-sm-6",
                                children: this.renderSendButton()
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-12 col-sm-6",
                                children: this.renderSignInButton()
                            })
                        ]
                    });
                }
        }
    }
    renderEmail() {
        if (!this.props.email) {
            return null;
        }
        return /*#__PURE__*/ _jsx("p", {
            className: styles.email,
            children: this.props.email
        });
    }
    renderHeader() {
        const { headerMessage } = this;
        if (!headerMessage) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("header", {
            className: "pageHeader",
            children: [
                /*#__PURE__*/ _jsx("h1", {
                    className: "text--h2",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, headerMessage))
                }),
                this.renderEmail()
            ]
        });
    }
    renderImage() {
        const identityProviderType = get(this.props.inactiveIdentity, 'identityProviderType');
        switch(identityProviderType){
            case 'ContourCloud':
                return /*#__PURE__*/ _jsx("img", {
                    className: styles.mainImage,
                    src: "/aid/assets/svg/confirm-cc-email.svg",
                    alt: ""
                });
            default:
                return /*#__PURE__*/ _jsx("img", {
                    className: styles.mainImage,
                    src: "/aid/assets/svg/confirm-email.svg",
                    alt: ""
                });
        }
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "pageContentBox",
            children: [
                this.renderHeader(),
                /*#__PURE__*/ _jsx("div", {
                    className: "text--light text-lh--15 mb-8",
                    children: this.renderText()
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text--center",
                    children: this.renderImage()
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "d-flex mt-8 row",
                    children: this.renderActions()
                }),
                this.renderSupportButton()
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            resendLock: 0,
            isSuccess: false,
            isInProgress: props.isInProgress
        };
    }
}
_define_property(ConfirmEmail, "contextType", AppContext);
_define_property(ConfirmEmail, "propTypes", {
    // Explicit props
    countryCode: PropTypes.string,
    token: PropTypes.string,
    password: PropTypes.string,
    email: PropTypes.string,
    returnUrl: PropTypes.string,
    invitationToken: PropTypes.string,
    // Implicit props
    inactiveIdentity: shapes.identity,
    isConfirmTokenExpired: PropTypes.bool,
    isInProgress: PropTypes.bool,
    hasError: PropTypes.bool,
    // Implicit actions
    onInit: PropTypes.func.isRequired,
    onConfirmEmail: PropTypes.func,
    onSendConfirmEmail: PropTypes.func,
    onUnsetInactiveIdentity: PropTypes.func
});
const mapStateToProps = (state)=>({
        inactiveIdentity: selectors.inactiveIdentity(state),
        isConfirmTokenExpired: selectors.isConfirmTokenExpired(state),
        isInProgress: selectors.isConfirmEmailInProgress(state),
        hasError: selectors.hasConfirmEmailErrors(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onInit: ()=>dispatch(actions.initAuth('confirmEmail')),
        onConfirmEmail: (token, returnUrl)=>dispatch(actions.confirmEmail(token, returnUrl)),
        onSendConfirmEmail: (email, password, identityProviderKey)=>dispatch(actions.sendConfirmEmail(email, password, identityProviderKey)),
        onUnsetInactiveIdentity: ()=>dispatch(actions.unsetInactiveIdentity())
    });
const ConnectedConfirmEmail = connect(mapStateToProps, mapDispatchToProps)(injectIntl(ConfirmEmail));
export default withStyles(styles)(ConnectedConfirmEmail);
